import React, { useState } from "react";
import { Word } from "./components/Word";
import { ButtonWrapperSC, EditedBoxSC, WordsBoxSC } from "./styled";
import { useAudioHandlesContext } from "hooks/useAudioHandlesContext";
import { IWord } from "./types";
import { Button } from "antd";
import { v4 } from "uuid";
import { InputTextSC, WordSC } from "./components/Word/styled";

interface EditBoxProps {
  addWord: (word: IWord) => void;
  moveWord: (from: number, to: number) => void;
  words: Array<IWord>;
  reset: () => void;
  updateWord: (index: number, newText: string) => void;
  activeWordId: string | null;
  setActiveWordId: (id: string | null) => void;
  save: (words: IWord[]) => void;
  deleteWord: (index: number) => void;
}

export const EditBox = ({
  words,
  updateWord,
  moveWord,
  reset,
  activeWordId,
  setActiveWordId,
  save,
  deleteWord,
}: EditBoxProps) => {
  const handles = useAudioHandlesContext();
  const [lastWord, setLastWord] = useState<IWord>({ id: v4(), text: "" });

  const handleSave = () => {
    if (lastWord.text) {
    }
    save([...words, lastWord]);
    handles.setEditedRecommendationSubtitle(null);
  };

  const handleReset = () => {
    setLastWord((prev) => ({ ...prev, text: "" }));
    reset();
  };

  return (
    <EditedBoxSC>
      <WordsBoxSC>
        {words.length > 0 &&
          words.map((word, index) => {
            return (
              <Word
                key={word.id}
                index={index}
                moveWord={moveWord}
                updateWord={updateWord}
                word={word}
                activeWordId={activeWordId}
                setActiveWordId={setActiveWordId}
                deleteWord={deleteWord}
              />
            );
          })}
        <WordSC>
          <InputTextSC
            autoFocus
            value={lastWord.text}
            onChange={(e) => setLastWord((word) => ({ ...word, text: e.target.value }))}
          />
        </WordSC>
      </WordsBoxSC>
      <ButtonWrapperSC>
        <Button type={"primary"} onClick={handleSave}>
          💾 Save
        </Button>
        <Button type={"primary"} onClick={handleReset}>
          🔄 Reset
        </Button>
        <Button type={"primary"} onClick={() => handles.setEditedRecommendationSubtitle(null)}>
          Close
        </Button>
      </ButtonWrapperSC>
    </EditedBoxSC>
  );
};

const buttonStyle: React.CSSProperties = {
  marginRight: "10px",
  padding: "8px 14px",
  borderRadius: "6px",
  border: "none",
  background: "#2196f3",
  color: "white",
  cursor: "pointer",
};
